import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

import { Modal, ModalBody, ModalFooter, Button, Input, Form, Select, ToggleSwitch, Tabs, TabContainer, Tooltip } from "@gpstrackit/react-controls";
import Accordion from "Components/Accordion";
import { Checkbox } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Grid, Icon, Divider, Chip, Alert } from "@mui/material";
import CustomSelect from 'Components/Select';

//Actions 
import {
    searchDealersRequest,
    accountsSearchRolesRequest,
    accountsGetRoleRequest,
    accountsGetAccountRequest,
    accountsCreateAccountRequest,
    accountsGetCustomRoleRequest,
    accountsEditAccountRequest,
    accountsGetRoleModuleTemplateRequest,
    accountsSearchTimeZonesRequest,
    searchEntityRequest,
    accountsCredencialValidationRequest,
    clearRedux,
} from 'Redux/actions';
import { getSfAccount } from './redux/saga'

//Helpers
import { passwordValidation, generatePassword } from 'Utils/helpers';
import { HasPermission } from "Core/security";

//Styles
import './index.scss';
import { getNullableType } from "graphql";

const FIELDS_VALIDATION_LIMITS = {
    username: {
        min: 4,
        max: 50
    },
    email: {
        max: 255
    },
}

const CreateEditAccount = (props) => {
    const { tableRef, getCompany, paramDealer } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);
    const formRolesRef = useRef(null);
    const formAddInfo = useRef(null);

    const languageOptions = [
        {
            id: 1,
            name: messages['english_label']
        },
        {
            id: 2,
            name: messages['spanish_label']
        },
    ]

    const [name, setName] = useState("");
    const [nameTitle, setNameTitle] = useState("");
    const [dealer, setDealer] = useState(paramDealer || null);
    const [timezone, setTimeZone] = useState(null);
    const [language, setLanguage] = useState(null);
    const [username, setUsername] = useState("");
    const [rol, setRol] = useState(null);
    const [email, setEmail] = useState("");
    const [tab, setTab] = useState(0);
    const [crmId, setCrmId] = useState("");
    const [internal, setInternal] = useState(false);
    const [currentAccount, setCurrentAccount] = useState(null);
    const [sfAccount, setSfAccount] = useState(null);
    const [tacRequired, setTacRequired] = useState(false);
    const [wexUserValidation, setWexUserValidation] = useState(false)

    const [rgeoEngine, setRgeoEngine] = useState(null);
    const [speedLimitEngine, setSpeedLimitEngine] = useState(getNullableType);

    //promiles
    const [promilesLogin, setPromilesLogin] = useState("");
    const [promilesEmail, setPromilesEmail] = useState("");

    //Connection Type
    const [connectionType, setConnectionType] = useState("ftp")

    //FuelCard
    const [fuelCardCompanyCode, setFuelCardCompanyCode] = useState("");

    //Switch
    const [showPromiles, setShowPromiles] = useState(false);
    const [showFuelCard, setShowFuelCard] = useState(false);

    //Web Services
    const [webServicesUsername, setWebServicesUsername] = useState("");
    const [webServicesPassword, setWebServicesPassword] = useState("");
    const [webServicesStatus, setWebServicesStatus] = useState("Active");

    const [reports, setReports] = useState([]);
    const [permission, setPermission] = useState([]);
    const [automaticPassword, setAutomaticPassword] = useState(false);
    const [selectedTags, setSelectdTags] = useState([]);
    const [readonly, setReadonly] = useState(false);
    const [tagMode, setTagMode] = useState("Standard");

    //Validations
    let additionalInfoTab = permission.some((item) => (item.moduleName === "Promiles" && item.checked) === true || (item.moduleName === "Fuel Cards" && item.checked));
    let validatePromiles = permission.some((item) => (item.moduleName === "Promiles" && item.checked) === true);
    let validateFuelCard = permission.some((item) => (item.moduleName === "Fuel Cards" && item.checked) === true);

    const {
        dealers,
        dealersLoading,
        timeZones,
        loadingEntity,
        tags
    } = useSelector(state => state.generalRedux);

    const {
        roles,
        rolesLoading,
        createAccount,
        roleModuleLoading,
        editAccount,
        loading,
        openModal,
        account,
        role,
        resultAccount,
        resultAccountLoading,
        customRole,
        customRoleLoading,
        roleModuleTemplate,
        roleModuleTemplateLoading,
        credentialValidation
    } = useSelector(state => state.createEditAccountRedux);

    const { user } = useSelector(state => state.securityRedux);

    const closeModal = () => {
        dispatch(clearRedux("CREATE_EDIT_ACCOUNT"));
        setName("");
        setLanguage(null);
        setTimeZone(null)
        setCrmId("");
        setInternal(true);
        setUsername("")
        setEmail("")
        setTab(0);
        setDealer(null);
        setRol(null);
        setReports([]);
        setPermission([]);
        setNameTitle("");
        setAutomaticPassword(false);
        setCurrentAccount(null);
        setPromilesLogin("");
        setPromilesEmail("");
        setFuelCardCompanyCode("");
        setTacRequired(false);
        setShowFuelCard(false);
        setShowPromiles(false);
        setReadonly(false);
        setTagMode("Standard");
    }

    const validateUsername = (value) => {
        //let regex = /^[a-z0-9]{3,20}$/;
        let regex = new RegExp(`^[a-z0-9]{${FIELDS_VALIDATION_LIMITS.username.min},${FIELDS_VALIDATION_LIMITS.username.max}}$`);

        return (value.match(regex) != null)
    }

    const saveAccount = () => {
        let permissionIds = permission.filter((item) => (item.checked)).map((item) => (item.moduleId));
        let reportsIds = reports.filter((item) => (item.checked)).map((item) => (item.moduleId));

        let payload = {
            name: name?.trim(),
            username: username?.trim(),
            email: email?.trim(),
            internal,
            crmId: crmId ? crmId?.trim() : '',
            timezoneId: timezone?.id,
            language: language?.id,
            dealerId: dealer?.id,
            roleId: rol?.id,
            compdata: {
                promiles: false,
                promilesLogin: "",
                promilesEmail: "",
                fuelCardCompanyCode: ""
            },
            integrations: [],
            tacRequired,
            rgeoEngine,
            speedLimitEngine,
            tagIds: selectedTags?.map(item => item.id) || [],
            readonly: readonly || false,
            tagMode: tagMode || "Standard"
        }

        let newRoleModules = [...permissionIds, ...reportsIds]
        payload.moduleIds = newRoleModules || [];
        if (additionalInfoTab) {

            if (validatePromiles && showPromiles) {
                payload.compdata.promiles = true
                payload.compdata.promilesLogin = promilesLogin?.trim();
                payload.compdata.promilesEmail = promilesEmail?.trim();
            }

            if (validateFuelCard && showFuelCard) {
                payload.compdata.fuelCardCompanyCode = fuelCardCompanyCode?.trim();

                if (webServicesUsername && webServicesPassword) {
                    payload.integrations.push({
                        status: webServicesStatus,
                        integrationId: 1,
                        parameters: {
                            username: webServicesUsername,
                            password: webServicesPassword,

                        }
                    })
                }

            }
        }
        dispatch(accountsCreateAccountRequest(payload));
    }

    const editAccountRequest = () => {
        let permissionIds = permission.filter((item) => (item?.checked)).map((item) => (item?.moduleId));
        let reportsIds = reports.filter((item) => (item?.checked)).map((item) => (item?.moduleId));
        let payload = {
            id: account?.id,
            name: name?.trim(),
            internal,
            crmId: crmId ? crmId?.trim() : '',
            timezoneId: timezone?.id,
            language: language?.id,
            dealerId: dealer?.id,
            roleId: rol?.id,
            compdata: {
                promiles: false,
                promilesLogin: "",
                promilesEmail: "",
                fuelCardCompanyCode: ""
            },
            integrations: [],
            tacRequired,
            rgeoEngine,
            speedLimitEngine,
            tagIds: selectedTags?.map(item => item.id) || [],
            readonly: readonly || false,
            tagMode: tagMode || "Standard"
        }

        let newRoleModules = [...permissionIds, ...reportsIds]
        payload.moduleIds = newRoleModules || []
        if (additionalInfoTab) {

            if (validatePromiles && showPromiles) {
                payload.compdata.promiles = true
                payload.compdata.promilesLogin = promilesLogin?.trim();
                payload.compdata.promilesEmail = promilesEmail?.trim();
            }

            if (validateFuelCard && showFuelCard) {
                payload.compdata.fuelCardCompanyCode = fuelCardCompanyCode?.trim();
                if (webServicesUsername && webServicesPassword) {
                    payload.integrations.push({
                        status: webServicesStatus,
                        integrationId: 1,
                        parameters: {
                            username: webServicesUsername,
                            password: webServicesPassword
                        }
                    })
                }
            }
        }
        dispatch(accountsEditAccountRequest(payload))
    }

    const getSfAccountForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getSfAccount(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    const mapProvider = ["google", "osm", "osmOnly"]

    useEffect(() => {
        if (openModal) {
            dispatch(accountsSearchTimeZonesRequest());
            dealers && dealers.length === 0 && dispatch(searchDealersRequest());
        }
    }, [openModal]);

    useEffect(() => {
        if (account) {
            dispatch(accountsGetAccountRequest(account.id))
        }
    }, [account])

    useEffect(() => {

        // Loading role modules for new accounts
        if (role && role.length > 0) {
            let currentPermission = role.filter((item) => item?.module?.category === "Permission");
            let currentReports = role.filter((item) => item?.module?.category === "Report");
            if (currentPermission && currentPermission.length > 0) {
                currentPermission = currentPermission.map((item) => ({ id: item?.id, checked: item?.isDefault, moduleId: item?.moduleId, moduleName: item?.module?.name, parentModuleId: item?.module?.parentModuleId, parentModuleName: item?.module?.parentModuleName, groupName: item?.module?.groupName }))
                setPermission(currentPermission);
            }
            if (currentReports && currentReports.length > 0) {
                currentReports = currentReports.map((item) => ({ id: item?.id, checked: item?.isDefault, moduleId: item?.moduleId, moduleName: item?.module?.name, parentModuleId: item?.module?.parentModuleId, parentModuleName: item?.module?.parentModuleName, groupName: item?.module?.groupName }))
                setReports(currentReports);
            }
            dispatch(clearRedux("CREATE_EDIT_ACCOUNT", { role: null }))
        }

        // Response when creating an account
        if (createAccount?.id) {
            NotificationManager.success(
                messages['create_account_the_account_was_created'],
                messages['create_account_create_title'],
                3000,
            );
            tableRef && tableRef?.current?.getData();
            getCompany && getCompany();
            closeModal();
        }

        if (customRole && customRole.length > 0) {
            let currentReports = reports;
            let currentPermission = permission;
            let customReportsOptions = customRole.filter((item) => item?.module?.category === "Report");
            let customPermissionsOptions = customRole.filter((item) => item?.module?.category === "Permission" /* && item?.module?.parentModuleId === null */);
            if (customReportsOptions && customReportsOptions.length > 0) {
                currentReports.map((item, index) => {
                    let indexReport = customReportsOptions.some((newreport) => newreport?.module.id === item.moduleId);
                    if (indexReport) {
                        currentReports[index].checked = true
                    }
                })

            }
            if (customPermissionsOptions && customPermissionsOptions.length > 0) {
                currentPermission.map((item, index) => {
                    let indexReport = customPermissionsOptions.some((newreport) => newreport?.module.id === item.moduleId);
                    if (indexReport) {
                        currentPermission[index].checked = true
                    }
                })
            }
            setReports(currentReports);
            setPermission(currentPermission);
            dispatch(clearRedux("CREATE_EDIT_ACCOUNT", { customRole: null }))
        }

        //Get current account information
        if (resultAccount?.id) {
            setCurrentAccount(resultAccount);
            let currentLanguage = languageOptions.find(item => item.id === resultAccount.language)
            let currentTimeZone = timeZones.find(item => item.id === resultAccount.timezoneId)
            setName(resultAccount?.name || "");

            let name = resultAccount?.name
            if (name.length >= 7) {
                name = name.substring(0, 25) + "...";
            }

            setNameTitle(name || "");
            setLanguage(currentLanguage || null);
            setTimeZone(currentTimeZone || null);
            setCrmId(resultAccount?.crmId || "");
            setInternal(resultAccount?.internal);
            setTacRequired(resultAccount?.tacRequired);
            setTab(0);
            dispatch(accountsSearchRolesRequest(resultAccount?.dealerId));
            setReports([]);
            setPermission([]);
            if (resultAccount?.dealer) setDealer(resultAccount?.dealer);
            if (resultAccount?.roleId && resultAccount?.role?.name) {
                dispatch(accountsGetRoleModuleTemplateRequest(resultAccount?.roleId));
                setRol({ id: resultAccount?.roleId, name: resultAccount?.role?.name });
            }
            dispatch(clearRedux("CREATE_EDIT_ACCOUNT", { resultAccount: null }));

            if (resultAccount?.compdata) {
                setPromilesEmail(resultAccount?.compdata?.promilesEmail || '');
                setPromilesLogin(resultAccount?.compdata?.promilesLogin || '');
                if (resultAccount?.compdata?.promilesLogin && resultAccount?.compdata?.promilesEmail) {
                    setShowPromiles(true);
                }
                setFuelCardCompanyCode(resultAccount?.compdata?.fuelCardCompanyCode || '');
                if (resultAccount?.compdata?.fuelCardCompanyCode) {
                    setShowFuelCard(true)
                }
            }

            if (resultAccount?.rgeoEngine && mapProvider.includes(resultAccount?.rgeoEngine)) {
                setRgeoEngine(resultAccount?.rgeoEngine)
            } else {
                setRgeoEngine("google")
            }
            if (resultAccount?.speedLimitEngine && mapProvider.includes(resultAccount?.speedLimitEngine)) {
                setSpeedLimitEngine(resultAccount?.speedLimitEngine)
            } else {
                setSpeedLimitEngine("google")
            }

            if (resultAccount && resultAccount?.integrations.length) {
                setWebServicesStatus(resultAccount?.integrations[0].status)
                setConnectionType("wsi")
                try {
                    let parameters = JSON.parse(resultAccount?.integrations[0].parameters)
                    if (parameters.username) {
                        setWexUserValidation(true);
                        setWebServicesUsername(parameters.username)
                        setWebServicesPassword(parameters.password)
                        if (parameters.username && parameters.password) {
                            setShowFuelCard(true)
                        }
                    }
                } catch (error) { }
            }

            setSelectdTags(resultAccount?.tags.length ? JSON.parse(resultAccount?.tags) : [])
            setReadonly(resultAccount?.readonly || false);
            setTagMode(resultAccount?.tagMode || "Standard");

        }
        //Account editing confirmation message
        if (editAccount?.id) {
            NotificationManager.success(
                messages['create_account_the_account_has_been_edited'],
                messages['create_account_edit_title'],
                3000,
            );
            tableRef && tableRef?.current?.getData();
            getCompany && getCompany();
            closeModal();
        }

        //Obtaining the template of the role modules
        if (roleModuleTemplate && roleModuleTemplate.length > 0) {
            let currentPermission = roleModuleTemplate.filter((item) => item?.module?.category === "Permission");
            let currentReports = roleModuleTemplate.filter((item) => item?.module?.category === "Report");

            if (currentPermission && currentPermission.length > 0) {
                currentPermission = currentPermission.map((item) => ({ id: item?.id, checked: !currentAccount?.customRoleId ? item?.isDefault : false, moduleId: item?.moduleId, moduleName: item?.module?.name, parentModuleId: item?.module?.parentModuleId, groupName: item?.module?.groupName, parentModuleName: item?.module?.parentModuleName }));
                setPermission(currentPermission);
            }

            if (currentReports && currentReports.length > 0) {
                currentReports = currentReports.map((item) => ({ id: item?.id, checked: !currentAccount?.customRoleId ? item?.isDefault : false, moduleId: item?.moduleId, moduleName: item?.module?.name, parentModuleId: item?.module?.parentModuleId, groupName: item?.module?.groupName, parentModuleName: item?.module?.parentModuleName }));
                setReports(currentReports);
            }

            if (currentAccount?.customRoleId) {
                dispatch(accountsGetCustomRoleRequest(currentAccount.customRoleId))
            }

            dispatch(clearRedux("CREATE_EDIT_ACCOUNT", { roleModuleTemplate: [] }))
        }
    }, [role, customRole, createAccount, resultAccount, editAccount, roleModuleTemplate]);

    useEffect(() => {
        timeZones && timeZones.length === 0 && dispatch(searchEntityRequest({ key: "timezones" }));
        paramDealer && dispatch(accountsSearchRolesRequest(paramDealer.id));
        dispatch(searchEntityRequest({ key: "tags" }));
    }, []);

    useEffect(() => {
        if (credentialValidation?.success) {
            setWexUserValidation(true);
            NotificationManager.success(
                messages['create_account_wex_credencials_success'],
                messages['create_account_edit_title'],
                3000,
            );
            dispatch(clearRedux("CREATE_EDIT_ACCOUNT", { credentialValidation: null }))
        } else if (credentialValidation?.error) {
            NotificationManager.error(
                messages['create_account_wex_credencials_error'],
                messages['create_account_edit_title'],
                3000,
            );
            dispatch(clearRedux("CREATE_EDIT_ACCOUNT", { credentialValidation: null }))
        }
    }, [credentialValidation])
    let validateSearchRoles = tab === 1 && customRoleLoading || tab === 1 && roleModuleTemplateLoading
    let saleforceAccount = dealer ? (dealer?.name?.toUpperCase() === "GLOBAL TRACKING COMMUNICATIONS" || dealer?.name?.toUpperCase() === "USCC SERVICES, LLC") : false;

    return (
        <Modal
            open={openModal}
            title={account ? `${messages['create_account_edit_title']} - ${nameTitle}` : messages['create_account_create_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading || roleModuleLoading || resultAccountLoading || validateSearchRoles}
            size="small"
            className="create-account-modal"
        >
            <ModalBody className="body-create-account">
                <Tabs
                    tab={+tab}
                    className="create-account-tabs"
                    onChange={(event) => setTab(event)}
                    disabled={true}
                >
                    <TabContainer disabled={true} index={0} label={messages['create_account_general']}>
                        <div className="create-account-tab-container">
                            <Form
                                ref={formRef}
                                onValidSubmit={() => {

                                    if (username && !account) {
                                        let userNameRules = validateUsername(username)
                                        if (!userNameRules) {
                                            NotificationManager.warning(
                                                messages['create_account_error_username'],
                                                messages['create_account_create_title'],
                                                3000,
                                            );
                                            return
                                        }
                                    }

                                    let checkPassword = true;
                                    if (checkPassword || account) setTab(1)

                                }}
                            >
                                <div style={{ margin: 10 }}>
                                    <Input
                                        type="text"
                                        label={messages['create_account_account_name']}
                                        placeholder={messages['create_account_account_name']}
                                        value={name}
                                        onChange={(value) => setName(value)}
                                        required
                                        requiredMessage={messages['required_field']}
                                        maxLength={110}
                                        minLength={3}
                                        minLengthMessage={`${messages['create_account_account_name_min_error']} 3`}
                                        maxLengthMessage={`${messages['create_account_account_name_max_error']} 110`}
                                    />
                                </div>
                                <div className="time-zone-container" style={{ margin: 10 }}>
                                    <Select
                                        id="language"
                                        value={language}
                                        options={languageOptions}
                                        label={messages['create_account_language']}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => setLanguage(value)}
                                        valueField="id"
                                        textField="name"
                                        placeholder={messages['create_account_select']}
                                    />
                                </div>
                                <div className="time-zone-container" style={{ margin: 10 }}>
                                    <Select
                                        id="time-zone"
                                        value={timezone}
                                        options={timeZones}
                                        label={messages['create_account_time_zone']}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => setTimeZone(value)}
                                        loading={loadingEntity}
                                        valueField="id"
                                        textField="name"
                                        placeholder={messages['create_account_select']}
                                    />
                                </div>
                                <div className="time-zone-container" style={{ margin: 10 }}>
                                    <Select
                                        id="dealers"
                                        options={dealers}
                                        value={dealer}
                                        label={messages['create_account_dealer']}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => {
                                            setRol(null);
                                            setDealer(value);
                                            dispatch(accountsSearchRolesRequest(value.id));
                                            setReports([]);
                                            setPermission([]);
                                            if (value?.name?.toUpperCase() !== "GLOBAL TRACKING COMMUNICATIONS") {
                                                if (sfAccount) {
                                                    setCrmId("")
                                                    setSfAccount(null)
                                                }
                                            }
                                        }}
                                        loading={dealersLoading}
                                        valueField="id"
                                        textField="name"
                                        placeholder={messages['create_account_select']}
                                        disabled={paramDealer}
                                    />
                                </div>
                                <Grid item xs={12} style={{ margin: 10 }}>
                                    <Select
                                        id="tags"
                                        options={tags}
                                        value={selectedTags}
                                        label={messages['create_account_tags']}
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => {
                                            setSelectdTags(value)
                                        }}
                                        loading={dealersLoading}
                                        valueField="id"
                                        textField="label"
                                        placeholder={messages['create_account_select']}
                                        multiple
                                        disabled={!HasPermission(user, "assgntgs", "c")}
                                    />
                                </Grid>
                                {
                                    saleforceAccount && (!crmId || crmId === "") &&
                                    <div style={{ margin: 10 }}>
                                        <CustomSelect
                                            async
                                            value={sfAccount}
                                            onChange={(item) => {
                                                setSfAccount(item);
                                                setCrmId(item.id)
                                            }}
                                            label={messages['create_account_crm']}
                                            placeholder={messages["create_account_crm"]}
                                            loadOptions={getSfAccountForSelect}
                                            getOptionLabel={e => `${e.name} - ${e.id}`}
                                            getOptionValue={e => e.id}
                                        />
                                    </div>
                                }
                                {
                                    saleforceAccount && crmId &&
                                    <div style={{ margin: 10, display: "flex" }}>
                                        <div style={{ width: "80%" }}>
                                            <Input
                                                type="text"
                                                label={messages['create_account_crm']}
                                                placeholder={messages['create_account_crm']}
                                                value={crmId}
                                                onChange={(value) => {
                                                    setCrmId(value)
                                                }}
                                                disabled={true}
                                            />
                                        </div>
                                        <div style={{ marginTop: 23 }}>
                                            <Button
                                                className="btn btn-cancel"
                                                onClick={() => {
                                                    setSfAccount(null);
                                                    setCrmId("");
                                                }}
                                            >
                                                {messages['common_clear']}
                                            </Button>
                                        </div>
                                    </div>
                                }
                                <div style={{ margin: 10, display: "flex" }}>
                                    <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px 0 0', width: "30%" }}>
                                        <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_account_internal']}</label>
                                        <ToggleSwitch
                                            id="accounts-internal"
                                            medium
                                            blueToggle
                                            optionLabels={[messages['create_account_yes'], messages['create_account_not']]}
                                            checked={internal}
                                            onChange={(checked) => setInternal(checked)}
                                        />
                                    </div>
                                </div>
                                <div style={{ margin: 10, display: "flex" }}>
                                    <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px 0 0', width: "30%" }}>
                                        <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_account_readonly']}</label>
                                        <ToggleSwitch
                                            id="accounts-readonly"
                                            medium
                                            blueToggle
                                            optionLabels={[messages['create_account_yes'], messages['create_account_not']]}
                                            checked={readonly}
                                            onChange={(checked) => setReadonly(checked)}
                                        />
                                    </div>
                                </div>
                                {
                                    HasPermission(user, "tagmd") &&
                                    <div style={{ margin: 10, display: "flex" }}>
                                        <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px 0 0', width: "30%" }}>
                                            <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['create_account_tag_mode']}</label>
                                            <ToggleSwitch
                                                id="accounts-tagMode"
                                                large
                                                blueToggle
                                                optionLabels={[messages['create_account_tag_mode_standard'], messages['create_account_tag_mode_inheritance']]}
                                                checked={tagMode === "Standard"}
                                                onChange={(checked) => setTagMode(checked ? "Standard" : "Inheritance")}
                                            />
                                        </div>
                                    </div>
                                }
                                {
                                    !account &&
                                    <div style={{ margin: 10 }}>
                                        <Input
                                            type="text"
                                            label={messages['create_account_username']}
                                            placeholder={messages['create_account_username']}
                                            autoComplete="new-password"
                                            value={username}
                                            onChange={(value) => setUsername(value)}
                                            required
                                            requiredMessage={messages['required_field']}
                                            maxLength={FIELDS_VALIDATION_LIMITS.username.max}
                                            minLength={FIELDS_VALIDATION_LIMITS.username.min}
                                            minLengthMessage={`${messages['create_account_username_error_min']} ${FIELDS_VALIDATION_LIMITS.username.min}`}
                                            maxLengthMessage={`${messages['create_account_username_error_max']} ${FIELDS_VALIDATION_LIMITS.username.max}`}
                                            onBlur={() => {
                                                let currentUsername = username || ''
                                                if (username) {
                                                    currentUsername = currentUsername.replace(/[^\w]/gi, '');
                                                    currentUsername = currentUsername.toLowerCase();
                                                    setUsername(currentUsername.trim());
                                                }
                                            }}
                                        />
                                    </div>
                                }
                                {!account &&
                                    <div style={{ margin: 10 }}>
                                        <Input
                                            type="email" maxLength={FIELDS_VALIDATION_LIMITS.email.max}
                                            label={messages['create_account_email']}
                                            placeholder={messages['create_account_email']}
                                            autoComplete="new-password"
                                            value={email}
                                            onChange={(value) => setEmail(value)}
                                            required
                                            requiredMessage={messages['required_field']}
                                            email
                                            emailMessage={messages['pmusers_user_email_is_invalid']}
                                        />
                                    </div>
                                }

                                <div style={{ textAlign: 'left', display: 'grid', padding: '0 10px 0 10px' }}>
                                    <label style={{ marginRight: 5 }} className="input-normal-label">{messages['create_account_verify_terms_conditions']}</label>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <ToggleSwitch
                                            id="tac-required"
                                            medium
                                            blueToggle
                                            optionLabels={[messages['create_account_yes'], messages['create_account_not']]}
                                            checked={tacRequired}
                                            onChange={(checked) => setTacRequired(checked)}
                                        />
                                        <Tooltip title={messages['create_account_verify_terms_conditions_message']}>
                                            <Icon style={{ cursor: 'pointer' }}>help</Icon>
                                        </Tooltip>
                                    </div>
                                </div>
                                {
                                    HasPermission(user, "cmprgeo") &&
                                    <div style={{ textAlign: 'left', display: 'grid', padding: '10px 10px' }}>
                                        <label style={{ marginRight: 5 }} className="input-normal-label">{messages['create_account_rgeo_engine']}</label>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Chip
                                                onClick={(() => {
                                                    if (HasPermission(user, "cmprgeo", "u"))
                                                        setRgeoEngine("google")
                                                })}
                                                style={{
                                                    marginRight: 5,
                                                    cursor: 'pointer',
                                                    backgroundColor: rgeoEngine === "google" ? '#1D2734' : "#00000014",
                                                    color: rgeoEngine === "google" ? 'white' : "#000000de"
                                                }}
                                                label="Google"
                                            />
                                            <Chip
                                                onClick={(() => {
                                                    if (HasPermission(user, "cmprgeo", "u"))
                                                        setRgeoEngine("osm")
                                                })}
                                                style={{
                                                    marginRight: 5,
                                                    cursor: 'pointer',
                                                    backgroundColor: rgeoEngine === "osm" ? '#1D2734' : "#00000014",
                                                    color: rgeoEngine === "osm" ? 'white' : "#000000de"
                                                }}
                                                label="OSM"
                                            />
                                        </div>
                                    </div>
                                }
                                {
                                    HasPermission(user, "cmpsle") &&
                                    <div style={{ textAlign: 'left', display: 'grid', padding: '10px 10px' }}>
                                        <label style={{ marginRight: 5 }} className="input-normal-label">{messages['create_account_speed_limit_engine']}</label>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Chip
                                                onClick={(() => {
                                                    if (HasPermission(user, "cmpsle", "u"))
                                                        setSpeedLimitEngine("google")
                                                })}
                                                style={{
                                                    marginRight: 5,
                                                    cursor: 'pointer',
                                                    backgroundColor: speedLimitEngine === "google" ? '#1D2734' : "#00000014",
                                                    color: speedLimitEngine === "google" ? 'white' : "#000000de"
                                                }}
                                                label="Google"
                                            />
                                            <Chip
                                                onClick={(() => {
                                                    if (HasPermission(user, "cmpsle", "u"))
                                                        setSpeedLimitEngine("osm")
                                                })}
                                                style={{
                                                    marginRight: 5,
                                                    cursor: 'pointer',
                                                    backgroundColor: speedLimitEngine === "osm" ? '#1D2734' : "#00000014",
                                                    color: speedLimitEngine === "osm" ? 'white' : "#000000de"
                                                }}
                                                label={messages['create_account_osm_with_fallback_google']}
                                            />
                                            <Chip
                                                onClick={(() => {
                                                    if (HasPermission(user, "cmpsle", "u"))
                                                        setSpeedLimitEngine("osmOnly")
                                                })}
                                                style={{
                                                    marginRight: 5,
                                                    cursor: 'pointer',
                                                    backgroundColor: speedLimitEngine === "osmOnly" ? '#1D2734' : "#00000014",
                                                    color: speedLimitEngine === "osmOnly" ? 'white' : "#000000de"
                                                }}
                                                label={messages['create_account_osm_only']}
                                            />
                                        </div>
                                    </div>
                                }
                            </Form>
                        </div>
                    </TabContainer>
                    <TabContainer disabled={true} index={1} label={messages['create_account_packages']}>
                        <div className="create-account-tab-container">
                            <Form
                                ref={formRolesRef}
                                onValidSubmit={() => {
                                    if (validatePromiles || validateFuelCard) setTab(2)
                                    else {
                                        if (account) editAccountRequest()
                                        else saveAccount()
                                    }
                                }}
                            >
                                <div className="time-zone-container" style={{ margin: 10 }}>
                                    <Select
                                        id="rol"
                                        options={roles}
                                        value={rol}
                                        label={messages['create_account_package']}
                                        required
                                        requiredMessage={messages['required_field']}
                                        onChange={(value) => {
                                            setRol(value);
                                            setReports([]);
                                            setPermission([]);
                                            dispatch(accountsGetRoleRequest(value.id));
                                        }}
                                        loading={rolesLoading}
                                        valueField="id"
                                        textField="name"
                                        placeholder={messages['select']}
                                    />
                                </div>
                            </Form>
                            <Grid container style={{ padding: '0 12px' }}>
                                <Accordion title={messages['create_account_report_options']}>
                                    <Grid container>
                                        {
                                            reports?.length > 0 ? reports.map((value, index) => {
                                                return (
                                                    <Grid key={index} item xs={12}>
                                                        <Checkbox
                                                            id={`${value?.moduleId}-index`}
                                                            label={`${value.groupName ? `${value.groupName} - ` : ''} ${value?.moduleName}`}
                                                            value={value.checked}
                                                            onChange={(checked) => {
                                                                let currentModules = reports
                                                                const currentIndex = currentModules.findIndex(object => object.id === value.id);
                                                                if (currentIndex !== -1) {
                                                                    currentModules[index].checked = checked;
                                                                }
                                                                setReports([...currentModules]);
                                                            }}
                                                        />
                                                    </Grid>
                                                )
                                            }) : messages['create_account_no_options']
                                        }
                                    </Grid>
                                </Accordion>
                                <Accordion title={messages['create_account_site_options']}>
                                    <Grid container>
                                        {
                                            permission?.length > 0 ? permission.map((value, index) => {
                                                return (
                                                    <Grid key={index} item xs={12}>
                                                        <Checkbox
                                                            id={`${value?.moduleId}-${index}`}
                                                            label={`${value.parentModuleName ? `${value.parentModuleName} - ` : ''} ${value.groupName ? `${value.groupName} - ` : ''} ${value?.moduleName}`}
                                                            value={value.checked}
                                                            onChange={(checked) => {
                                                                if (value.moduleName !== 'Maps') {
                                                                    let currentModules = permission
                                                                    const currentIndex = currentModules.findIndex(object => object.id === value.id);
                                                                    if (currentIndex !== -1) {
                                                                        currentModules[index].checked = checked;
                                                                    }
                                                                    setPermission([...currentModules]);
                                                                }
                                                            }}
                                                        />
                                                    </Grid>
                                                )
                                            }) : messages['create_account_no_options']
                                        }
                                    </Grid>
                                </Accordion>
                            </Grid>
                        </div>
                    </TabContainer>
                    {
                        additionalInfoTab &&
                        <TabContainer disabled={false} index={2} label={messages['create_account_additional_info']}>
                            <div className="create-account-tab-container">
                                <Form
                                    ref={formAddInfo}
                                    onValidSubmit={() => {
                                        if (account) editAccountRequest()
                                        else saveAccount()
                                    }}
                                >
                                    {validatePromiles &&
                                        <>
                                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 5 }}>
                                                <div style={{ width: 100 }}>
                                                    <label style={{ margin: '0 10px 0' }} className="input-normal-label">{messages['create_account_promiles']}</label>
                                                </div>
                                                <ToggleSwitch
                                                    id="accounts-show-promiles"
                                                    medium
                                                    blueToggle
                                                    optionLabels={[messages['create_account_yes'], messages['create_account_not']]}
                                                    checked={showPromiles}
                                                    onChange={(checked) => {
                                                        setShowPromiles(checked)
                                                        if (!checked) {
                                                            setPromilesLogin("");
                                                            setPromilesEmail("");
                                                        }
                                                    }}
                                                />
                                            </div>
                                            {
                                                showPromiles ? (
                                                    <>
                                                        <div style={{ margin: 10 }}>
                                                            <Input
                                                                type="text"
                                                                label={messages['create_account_promiles_username']}
                                                                placeholder={messages['create_account_promiles_username']}
                                                                value={promilesLogin}
                                                                onChange={(value) => setPromilesLogin(value)}
                                                                required
                                                                requiredMessage={messages['required_field']}
                                                            />
                                                        </div>
                                                        <div style={{ margin: 10 }}>
                                                            <Input
                                                                type="email" maxLength={FIELDS_VALIDATION_LIMITS.email.max}
                                                                label={messages['create_account_promiles_email']}
                                                                placeholder={messages['create_account_promiles_email']}
                                                                autoComplete="new-password"
                                                                value={promilesEmail}
                                                                onChange={(value) => setPromilesEmail(value)}
                                                                required
                                                                requiredMessage={messages['required_field']}
                                                                email
                                                                emailMessage={messages['pmusers_user_email_is_invalid']}
                                                            />
                                                        </div>
                                                    </>
                                                ) : <></>
                                            }
                                        </>
                                    }
                                    {
                                        validateFuelCard &&
                                        <>
                                            <div style={{ display: 'flex', alignItems: 'center', marginTop: 15 }}>
                                                <div style={{ width: 100 }}>
                                                    <label style={{ margin: '0 10px 0' }} className="input-normal-label">{messages['create_account_fuel_cards']}</label>
                                                </div>
                                                <ToggleSwitch
                                                    id="accounts-show-fuel-card"
                                                    medium
                                                    blueToggle
                                                    optionLabels={[messages['create_account_yes'], messages['create_account_not']]}
                                                    checked={showFuelCard}
                                                    onChange={(checked) => {
                                                        setShowFuelCard(checked)
                                                        if (!checked) {
                                                            setFuelCardCompanyCode("")
                                                            setWebServicesPassword("")
                                                            setWebServicesUsername("")
                                                            setConnectionType("ftp")
                                                        }
                                                    }}
                                                />
                                            </div>
                                            {
                                                showFuelCard ? (
                                                    <>
                                                        <div style={{ margin: 10 }}>
                                                            <label style={{ marginRight: 5 }} className="input-normal-label">{messages['create_account_fuel_card_integrations']}</label>
                                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                <Chip
                                                                    onClick={(() => {
                                                                        if (connectionType !== "ftp") {
                                                                            setConnectionType("ftp")
                                                                            setWebServicesPassword("");
                                                                            setWebServicesStatus("Active");
                                                                            setWebServicesUsername("");
                                                                            setWexUserValidation(false);
                                                                        }
                                                                    })}
                                                                    style={{
                                                                        marginRight: 5,
                                                                        cursor: 'pointer',
                                                                        backgroundColor: connectionType === "ftp" ? '#1D2734' : "#00000014",
                                                                        color: connectionType === "ftp" ? 'white' : "#000000de"
                                                                    }}
                                                                    label="FTP"
                                                                />
                                                                <Chip
                                                                    onClick={(() => {
                                                                        if (connectionType !== "wsi") {
                                                                            setFuelCardCompanyCode("");
                                                                            setConnectionType("wsi");
                                                                            setWexUserValidation(false);
                                                                        }
                                                                    })}
                                                                    style={{
                                                                        marginRight: 5,
                                                                        cursor: 'pointer',
                                                                        backgroundColor: connectionType === "wsi" ? '#1D2734' : "#00000014",
                                                                        color: connectionType === "wsi" ? 'white' : "#000000de"
                                                                    }}
                                                                    label={messages['create_account_web_service_integration']}
                                                                />
                                                            </div>
                                                        </div>
                                                        {
                                                            connectionType === "ftp" ? (
                                                                <div style={{ margin: 10 }}>
                                                                    <Input
                                                                        type="text"
                                                                        label={messages['create_account_fuel_card_company_code']}
                                                                        placeholder={messages['create_account_fuel_card_company_code']}
                                                                        value={fuelCardCompanyCode}
                                                                        onChange={(value) => setFuelCardCompanyCode(value)}
                                                                        required
                                                                        requiredMessage={messages['required_field']}
                                                                    />
                                                                </div>
                                                            ) : <></>
                                                        }
                                                        {
                                                            connectionType === "wsi" ? (
                                                                <>
                                                                    <div style={{ margin: 10 }}>
                                                                        <Input
                                                                            type="text"
                                                                            label={messages['create_account_username']}
                                                                            placeholder={messages['create_account_username']}
                                                                            value={webServicesUsername}
                                                                            onChange={(value) => {
                                                                                setWexUserValidation(false)
                                                                                setWebServicesUsername(value)
                                                                            }}
                                                                            required
                                                                            requiredMessage={messages['required_field']}
                                                                            autoComplete="new-password"
                                                                        />
                                                                    </div>
                                                                    <div style={{ margin: 10 }}>
                                                                        <Input
                                                                            type="password"
                                                                            label={messages['create_account_password']}
                                                                            placeholder={messages['create_account_password']}
                                                                            value={webServicesPassword}
                                                                            onChange={(value) => {
                                                                                setWexUserValidation(false)
                                                                                setWebServicesPassword(value)
                                                                            }}
                                                                            required
                                                                            requiredMessage={messages['required_field']}
                                                                            autoComplete="new-password"
                                                                        />
                                                                        {
                                                                            !wexUserValidation ? <Alert severity="info" style={{ marginTop: 10 }}>{messages['create_account_wex_credencials_message']}</Alert> : <></>
                                                                        }
                                                                    </div>
                                                                    <div style={{ margin: 10 }}>
                                                                        <Button
                                                                            disabled={!webServicesPassword || !webServicesUsername || wexUserValidation}
                                                                            style={{ width: '100%' }}
                                                                            className="btn-dark-blue"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                if (webServicesUsername && webServicesPassword) {
                                                                                    dispatch(accountsCredencialValidationRequest({
                                                                                        username: webServicesUsername,
                                                                                        password: webServicesPassword
                                                                                    }))
                                                                                }
                                                                            }}
                                                                        >
                                                                            {messages['create_account_validate_credentials']}
                                                                        </Button>
                                                                    </div>
                                                                    <div style={{ margin: 10 }}>
                                                                        <label style={{ marginRight: 5 }} className="input-normal-label">{messages['create_account_web_services_status']}</label>
                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                            <Chip
                                                                                onClick={(() => setWebServicesStatus("Active"))}
                                                                                style={{
                                                                                    marginRight: 5,
                                                                                    cursor: 'pointer',
                                                                                    backgroundColor: webServicesStatus === "Active" ? '#1D2734' : "#00000014",
                                                                                    color: webServicesStatus === "Active" ? 'white' : "#000000de"
                                                                                }}
                                                                                label={messages['create_account_active']}
                                                                            />
                                                                            <Chip
                                                                                onClick={(() => setWebServicesStatus("Inactive"))}
                                                                                style={{
                                                                                    marginRight: 5,
                                                                                    cursor: 'pointer',
                                                                                    backgroundColor: webServicesStatus === "Inactive" ? '#1D2734' : "#00000014",
                                                                                    color: webServicesStatus === "Inactive" ? 'white' : "#000000de"
                                                                                }}
                                                                                label={messages['create_account_inactive']}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : <></>
                                                        }
                                                    </>
                                                ) : <></>
                                            }
                                        </>
                                    }
                                </Form>
                            </div>
                        </TabContainer>
                    }
                </Tabs>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => {
                        if (tab === 0) closeModal();
                        else setTab(tab - 1);
                    }}
                >
                    {tab === 0 ? messages['common_cancel'] : messages['common_back']}
                </Button>
                <Button
                    disabled={(showFuelCard && connectionType === "wsi" && !wexUserValidation)}
                    className="btn-dark-blue"
                    onClick={() => {
                        if (tab === 0) {
                            formRef?.current?.submit();
                        } else if (tab === 1) {
                            formRolesRef?.current?.submit();
                        } else if (tab === 2) {
                            formAddInfo?.current?.submit();
                        }
                    }}
                >
                    {tab === 0 || (tab === 1 && additionalInfoTab) ? messages['common_next'] : messages['save']}
                </Button>
            </ModalFooter>
        </Modal >
    );
}
export default CreateEditAccount